// @flow

import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';

import startIcon from '../../../../../assets/img/dashboard/star.svg';
import {Typography} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';

type Props = {
  className?: string,
  id: number,
  text: string,
  price: string,
  img?: string,
};

const useStyles = makeStyles(theme => ({
  row: {
    width: '100%',
    margin: theme.spacing(2, 0),
  },
  numberText: {
    margin: theme.spacing(0, 1),
    color: colors.grey700,
    fontSize: 12,
    fontWeight: 600,
  },
  center: {
    display: 'flex',
    alignItems: 'center',
  },
  priceText: {
    color: colors.grey900,
    fontSize: 14,
    fontWeight: 500,
    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing(2),
    },
  },
  orderRow: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    width: 44,
  },
  text: {
    color: colors.grey900,
    fontSize: 14,
  },
  centerContent: {
    flexGrow: '1',
    display: 'flex',
  },
}));

export default function RowItemSales(props: Props) {
  const {id, text, price, img = null, className} = props;
  const classes = useStyles();
  return (
    <div
      className={`${classes.center} ${classes.row} ${
        className ? className : ''
      }`}
    >
      <div className={`${classes.center} ${classes.orderRow}`}>
        <img src={startIcon} alt="star icon" />
        <Typography className={classes.numberText}>{id}</Typography>
      </div>
      <div className={classes.centerContent}>
        {img}
        <Typography className={classes.text}>{text}</Typography>
      </div>
      <Typography className={classes.priceText}>{price}</Typography>
    </div>
  );
}

RowItemSales.propTypes = {
  className: PropTypes.string,
  id: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  img: PropTypes.string,
};
